import Parcel from '../../../api/Parcel';
import ResponseResult from '../../../api/ResponseResult';
import ResponseError from '../../../api/ResponseError';


export default class ProductAttributeByProductParcel extends Parcel {

    constructor(productId) {
        super();

        this.setEndpoint('/api/product-attribute/by-product');

        this.setRequestMethod('GET');

        this.setQueryParam('product_id', productId);
    }

    parseResponseError(rawError) {
        return new ResponseError(rawError.message);
    }

    parseResponseResult(rawResult) {
        if (rawResult.error) {
            return new ResponseResult(null, new ResponseError(rawResult.error.message));
        }

        return new ResponseResult(rawResult.data, null);
    }
}
